// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E1vC3DwG_AlXiYXhvfVd{border-radius:6px;max-width:calc(100vw - 10px)}.E1vC3DwG_AlXiYXhvfVd:hover{background:var(--background-neutral-subtle);border-radius:6px}.JVEKSUnesGoR8m7JwiOr{align-items:center;height:100%;padding:8px}.JVEKSUnesGoR8m7JwiOr:first-child{border-radius:6px 0 0 6px;width:100%}.JVEKSUnesGoR8m7JwiOr:last-child{border-radius:0 6px 6px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `E1vC3DwG_AlXiYXhvfVd`,
	"cell": `JVEKSUnesGoR8m7JwiOr`
};
export default ___CSS_LOADER_EXPORT___;
